(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/newstt/views/news-tt-list.js') >= 0) return;  svs.modules.push('/components/statistics/newstt/views/news-tt-list.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.statistics=_svs.statistics||{};
_svs.statistics.newstt=_svs.statistics.newstt||{};
_svs.statistics.newstt.templates=_svs.statistics.newstt.templates||{};
svs.statistics.newstt.templates.news_tt_list = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"news\">\n  <h3 class=\"statistics-header\">"
    + container.escapeExpression(((helper = (helper = helpers.header || (depth0 != null ? depth0.header : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"header","hash":{},"data":data}) : helper)))
    + "</h3>\n  <ul class=\"news-list list-style-none margin-bottom-0\"></ul>\n</div>\n";
},"useData":true});
Handlebars.partials['components-statistics-newstt-news_tt_list'] = svs.statistics.newstt.templates.news_tt_list;
})(svs, Handlebars);

 })(window);